<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['venues.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'VENUES.VENUES_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['venues.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'VENUES.VENUES_LIST.ADD' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="venuesResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Venues', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'VENUES.VENUES_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'VENUES.VENUES_LIST.ID' | translate }}"
      filter="numeric"
      [width]="80"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'VENUES.VENUES_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/settings/venues/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="city.country.name"
      title="{{ 'VENUES.VENUES_LIST.COUNTRY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city.country.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-country-select [filter]="filter" [field]="'city.country_id'"></app-kendo-country-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-country-box [country]="dataItem?.city?.country"></app-country-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="city.name"
      title="{{ 'VENUES.VENUES_LIST.CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('city.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter"></app-kendo-city-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="note"
      title="{{ 'VENUES.VENUES_LIST.NOTE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('note')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="address"
      title="{{ 'VENUES.VENUES_LIST.ADDRESS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('address')"
    ></kendo-grid-column>

    <kendo-grid-column
      [width]="90"
      field="capacity"
      filter="text"
      [columnMenu]="false"
      title="{{ 'VENUES.VENUES_LIST.CAPACITY' | translate }}"
      [hidden]="isHiddenColumn('capacity', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [width]="90"
      field="parking"
      filter="text"
      [columnMenu]="false"
      title="{{ 'VENUES.VENUES_LIST.PARKING' | translate }}"
      [hidden]="isHiddenColumn('parking', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [width]="90"
      field="distance_to_center"
      filter="numeric"
      [columnMenu]="false"
      title="{{ 'VENUES.VENUES_LIST.DISTANCE_TO_CENTER' | translate }}"
      [hidden]="isHiddenColumn('distance_to_center')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [width]="90"
      field="distance_to_airport"
      filter="numeric"
      [columnMenu]="false"
      title="{{ 'VENUES.VENUES_LIST.DISTANCE_TO_AIRPORT' | translate }}"
      [hidden]="isHiddenColumn('distance_to_airport')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      [width]="90"
      field="distance_to_tr_point"
      filter="numeric"
      [columnMenu]="false"
      title="{{ 'VENUES.VENUES_LIST.DISTANCE_TO_TR_POINT' | translate }}"
      [hidden]="isHiddenColumn('distance_to_tr_point')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="distance_to_tr_point_name"
      filter="text"
      title="{{ 'VENUES.VENUES_LIST.DISTANCE_TO_TR_POINT_NAME' | translate }}"
      [hidden]="isHiddenColumn('distance_to_tr_point_name')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="lat"
      title="{{ 'VENUES.VENUES_LIST.LAT' | translate }}"
      [hidden]="isHiddenColumn('lat', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="long"
      title="{{ 'VENUES.VENUES_LIST.LONG' | translate }}"
      [hidden]="isHiddenColumn('long', true)"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'VENUES.VENUES_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.created_at?.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'VENUES.VENUES_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'VENUES.VENUES_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['venues.show']
            )
          "
          [link]="['/settings/venues/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION, UserRoleType.MARKETING], ['venues.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['venues.translations'])"
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'VENUES.VENUES_LIST.UPLOAD_GALLERY' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.VENUE"
        ></app-media-library-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'VENUES.VENUES_LIST.UPLOAD_HALLS' | translate"
          container="body"
          [collectionName]="'halls'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.VENUE"
        >
        </app-media-library-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'VENUES.VENUES_LIST.UPLOAD_WIDE_BACKGROUND' | translate"
          container="body"
          [collectionName]="'wide-background'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.VENUE"
        ></app-media-library-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['venues.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
